import { render, staticRenderFns } from "./tcustrelationship.vue?vue&type=template&id=3f029b3c&"
import script from "./tcustrelationship.vue?vue&type=script&lang=js&"
export * from "./tcustrelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports